export enum AuthSocialErrors {
  SignInThirdPartyFailed = "sign in third party failed",
}
